import { Autocomplete, Box, Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ComercialInterfaceHeader from "../../../../../components/comercial/ComercialInterfaceHeader";
import PriceInput from "../../../../../components/general/PriceInput";
import { sharedStyles } from "../../../../../styles/shared";

export const ServiceDataForm = ({
        register,
        errors,
        refs,
        services,
        serviceCategory,
        setServiceCategory,
        durationOfService,
        setDurationOfService,
        fixedPrice,
        setFixedPrice,
        dynamicPriceAllowed,
        setIsDynamicPriceAllowed,
        pricesAreValid,
        submittedOnce,
        selectedServiceStore,
                                }: any) => {
    const { t } = useTranslation();

    return (
        <>
            <ComercialInterfaceHeader title={t("servicePage.management.form.titleAdd")} />
            <Box sx={sharedStyles.verticalContent}>
                <Box sx={{ ...sharedStyles.verticalContent, flexDirection: "row", "@media(max-width:800px)": { flexDirection: "column" } }}>
                    <Box sx={{ ...sharedStyles.verticalContent, width: "65%", "@media(max-width:800px)": { width: "100%" } }}>
                        <TextField
                            size="small"
                            label={t("servicePage.management.form.serviceName")}
                            inputRef={refs.serviceName}
                            defaultValue={selectedServiceStore?.serviceName || selectedServiceStore?.Service?.name || ""}
                            {...register("name")}
                            error={!!errors.name}
                            helperText={errors.name?.message}
                            fullWidth
                        />
                        <Box sx={{ ...sharedStyles.verticalContent, flexDirection: "row" }}>
                            <Autocomplete
                                freeSolo
                                options={services?.map((service: any) => service.name) || []}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={t("servicePage.management.form.category")}
                                        size="small"
                                        value={serviceCategory}
                                        onChange={(e) => setServiceCategory(e.target.value)}
                                        {...register("category")}
                                        error={!!errors.category}
                                        helperText={errors.category?.message}
                                    />
                                )}
                                fullWidth
                                onInputChange={(_, value) => setServiceCategory(value)}
                            />
                            <TextField
                                size="small"
                                label={t("servicePage.management.form.duration")}
                                type="number"
                                value={durationOfService}
                                onChange={(e) => setDurationOfService(Number(e.target.value))}
                                InputProps={{ inputProps: { min: 1 } }}
                            />
                        </Box>
                        <TextField
                            size="small"
                            label={t("servicePage.management.form.description")}
                            multiline
                            rows={4}
                            fullWidth
                            inputRef={refs.description}
 defaultValue={selectedServiceStore?.description || ""}
                            placeholder={t("servicePage.management.form.descriptionPlaceholder")}
                        />
                    </Box>

                    <Box sx={{ ...sharedStyles.verticalContent, width: "35%", "@media(max-width:800px)": { width: "100%" } }}>
                        {!dynamicPriceAllowed && (
                            <PriceInput
                                label={t("servicePage.management.form.fixedPrice")}
                                size="small"
                                placeholder={t("servicePage.management.form.pricePlaceholder")}
                                value={fixedPrice}
                                onChange={(e) => setFixedPrice(Number(e.target.value))}
                                error={!pricesAreValid && submittedOnce}
                                helperText={!pricesAreValid && submittedOnce && t("servicePage.management.form.priceError")}
                                autoComplete="off"
                                inputRef={(input) => input && !pricesAreValid && submittedOnce && input.focus()}
                                fullWidth
                            />
                        )}
                        <Box>
                            <FormControlLabel
                                control={<Checkbox checked={dynamicPriceAllowed} onChange={() => setIsDynamicPriceAllowed(!dynamicPriceAllowed)} />}
                                label={t("servicePage.management.form.dynamicPriceLabel")}
                                componentsProps={{ typography: { fontWeight: 600 } }}
                            />
                            <Typography textAlign="justify">
                                {t("servicePage.management.form.dynamicPriceDescription")}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};